import React from 'react';

import ElementConstants from '../../../../shared/constants/elements';

import InputGroup from '../../../components/form-elements/input-groups/input-group';
import SelectMenuElement from '../../../components/form-elements/input-groups/select-menu';
import TableElement from '../../../components/form-elements/input-groups/table';
import RatingElement from '../../../components/form-elements/input-groups/rating';

const InputGroupElements = {
	CHECKBOXES: {
		type: ElementConstants.INPUT_GROUPS.CHECKBOXES,
		component: <InputGroup type={ElementConstants.INPUT_GROUPS.CHECKBOXES} />
	},
	RADIO_BUTTONS: {
		type: ElementConstants.INPUT_GROUPS.RADIO_BUTTONS,
		component: <InputGroup type={ElementConstants.INPUT_GROUPS.RADIO_BUTTONS} />
	},
	SELECT_MENU: {
		type: ElementConstants.INPUT_GROUPS.SELECT_MENU,
		component: <SelectMenuElement />
	},
	TABLE: {
		type: ElementConstants.INPUT_GROUPS.TABLE,
		component: <TableElement />
	},
	RATING: {
		type: ElementConstants.INPUT_GROUPS.RATING,
		component: <RatingElement />
	}
}

export default InputGroupElements;



// WEBPACK FOOTER //
// ./src/main/webapps/features/form-builder/react/editor/constants/elements/editor/input-groups.js